export const getPageMargins = () => {
    return `@page { margin: 1cm 1cm 1cm 1cm !important; }`;
};

export const getPageMarginsZero = () => {
    return `@page { margin: 0cm 0cm 0cm 0cm !important; }`;
};
export const PAGE_SIZE = 10
export const USER_ADMINISTRATOR = 101
export const USER_TRAINEE = 102
export const PRICE = "11,000"
export const GOOGLE_CLIENT_ID = "832181054141-b16hog8kas97n1d71ugl0tsqd3d1rrgg.apps.googleusercontent.com"